import { countries } from '@/constants';

export default {
  title: {
    title: 'Title',
  },
  date: {
    title: 'Date',
    type: 'date',
    params: {
      format: 'MMMM Do YYYY',
    },
  },
  notes: {
    title: 'Notes',
    type: 'textarea',
    params: {
      newline: true,
    },
  },
  contact: {
    title: 'Contact Details',
    type: 'multi',
    params: {
      fields: {
        contactName: {
          title: 'Name',
        },
        companyName: {
          title: 'Company',
        },
        address: {
          title: 'Address',
        },
        country: {
          title: 'Country',
          type: 'dropdown',
          params: {
            title: 'Select your country',
            values: countries,
          },
        },
        email: {
          title: 'Email',
          type: 'text',
          params: {
            attributes: {
              type: 'email',
            },
          },
        },
        phoneNumber: {
          title: 'Phone',
        },
        website: {
          title: 'Website',
          type: 'text',
          params: {
            attributes: {
              type: 'url',
            },
          },
        },
      },
    },
  },
};
